/** 展示格式化：金额一律按「分」入库，只在渲染时转成元。 */

export function formatMoney(minor: number, currency = 'CNY'): string {
  if (!Number.isFinite(minor)) return '—';
  const yuan = (minor / 100).toFixed(2);
  return currency === 'CNY' ? `¥${yuan}` : `${yuan} ${currency}`;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('zh-CN', { hour12: false });
}

export function formatRelative(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const diffMs = Date.now() - date.getTime();
  const minutes = Math.round(diffMs / 60000);
  if (Math.abs(minutes) < 1) return '刚刚';
  if (Math.abs(minutes) < 60) return `${minutes} 分钟前`;
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return `${hours} 小时前`;
  const days = Math.round(hours / 24);
  if (Math.abs(days) < 30) return `${days} 天前`;
  return date.toLocaleDateString('zh-CN');
}
